"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function assertOK(expression, message) {
    if (!expression) {
        throw new Error(message);
    }
}
exports.assertOK = assertOK;
//# sourceMappingURL=assert.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/util/assert.js
// module id = 33
// module chunks = 0